var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4786FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.05305C9.1691 8.53198 9.47887 8.06826 9.89533 7.71235C10.3118 7.35644 10.8191 7.12255 11.3601 7.03671C11.9012 6.95087 12.4551 7.01624 12.9613 7.22577C13.4675 7.4353 13.9058 7.78092 14.2279 8.22407C14.55 8.66721 14.7429 9.19061 14.7859 9.73674C14.829 10.2829 14.72 10.8304 14.4714 11.3185C14.2227 11.8067 13.8443 12.2162 13.3773 12.5025C12.9102 12.7887 12.373 12.9402 11.8252 12.9402V13.9308M11.8745 16.9008V16.9998L11.7759 17V16.9008H11.8745Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.27c9d791ea10a6206e0c05f7ead18eec.svg";
export { ForwardRef as ReactComponent };